import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.canReply)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "gfu-comment-reply gfu-btn gfu-btn--light-outline gfu-btn--soft gfu-btn--tight gfu-btn--lowercase",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('reply'))),
          "data-qa": "project-comment-button:Reply"
        }, _toDisplayString(_ctx.Resources.Comments.ReplyCommentAction), 1 /* TEXT */))
      : (_openBlock(), _createBlock(_component_tooltip, {
          key: 1,
          text: $options.tooltipText,
          "data-qa": "project-comment-reply:Tooltip"
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _mergeProps(_ctx.$attrs, {
              class: "gfu-comment-reply gfu-btn gfu-btn--light-outline gfu-btn--soft gfu-btn--tight gfu-btn--lowercase",
              "data-qa": "project-comment-button:Reply"
            }), _toDisplayString(_ctx.Resources.Comments.ReplyCommentAction), 17 /* TEXT, FULL_PROPS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["text"]))
  ]))
}